import styled from "styled-components"

import { maxWidth, minWidth } from "utils"

import CroppedImage from "components/cropped-image"

export const Wrapper = styled.div`
  position: relative;
  width: calc(100% - 5.4rem);
  margin: 0 2.7rem 2rem;

  ::after {
    content: "";
    position: absolute;
    bottom: -2px;
    left: 0;
    right: 0;
    border-top: 3px solid #eee;
  }

  ${minWidth.tablet`
    max-width: 58rem;
    margin: 0 auto 4rem;
  `}

  ${minWidth.hamburgerLarge`
    max-width: 72.5rem;
    margin: 0 auto 6rem;
  `}
`

export const Details = styled.div`
  display: flex;
  flex-wrap: wrap;

  ${maxWidth.tablet`
    justify-content: center;
  `}
`

export const Item = styled.div`
  width: 18rem;
  padding: 3.6rem 1.5rem 1.8rem;
  border-bottom: 1px solid #eee;
  display: flex;
  flex-direction: column;
  text-align: center;
  align-items: center;

  ${maxWidth.tablet`
    width: 50%;
    padding: 3.6rem 0 1.8rem;
  `}
`

export const Heading = styled.h3`
  font-family: "Abril", "Helvetica Neue", Helvetica, Arial, sans-serif;
  font-size: 2.4rem;
  font-weight: 500;
  line-height: 1.5;
  letter-spacing: normal;
  text-align: center;
  color: ${({ theme }) => theme.article.color};
`

export const Image = styled(CroppedImage)`
  width: 70%;
  padding-top: 75%;
`

export const Text = styled.p`
  color: ${({ theme }) => theme.colors.text.primary};
  font-family: Maax, "Helvetica Neue", Helvetica, Arial, sans-serif;
  font-size: 1.6rem;
  line-height: 1.35;
  text-align: center;
`

export const LinkText = styled(Text)`
  font-weight: 500;
  text-decoration: underline;
`
